import { Component, Input, AfterViewChecked, Inject } from '@angular/core';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';

export const PASSWORD_HINTS: Array<{ name: string; formKey: string }> = [
  {
    name: '8-64 characters',
    formKey: 'invalidMinMaxPassword',
  },
  {
    name: 'Minimum 1 number',
    formKey: 'invalidAtleatOnePassword',
  },
  {
    name: 'Minimum 1 upper case letter and 1 lower case letter',
    formKey: 'invalidOneUpLower',
  },
  {
    name: 'Minimum 1 special character (accepted symbols are _ ! . & @ -)',
    formKey: 'invalidAcceptSymbols',
  },
  {
    name: 'Maximum 2 characters repeated beside themselves, e.g.; the two "o"s in "Looking4!"',
    formKey: 'invalidMaxTwoCharRepeat',
  },
];

@Component({
  selector: 'cigna-password-hints',
  templateUrl: './password-hints.component.html',
  styleUrls: ['./password-hints.component.scss'],
})
export class PasswordHintsComponent implements AfterViewChecked {
  @Input() errors: any;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() fnlnCheckReq: boolean;

  isAuth0: boolean;
  passowrdHints = PASSWORD_HINTS;

  constructor(
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
  ) {
    this.isAuth0 = this.envConfig.authMethod === 'auth0';
  }

  ngAfterViewChecked() {
    const flnFound = this.passowrdHints.filter(
      (fl) => fl.formKey === 'invalidDisallowNameId',
    );

    if (this.isAuth0) {
      const i = this.passowrdHints.findIndex(
        (fl) => fl.formKey === 'invalidMinMaxPassword',
      );
      this.passowrdHints[i] = {
        name: '9-64 characters',
        formKey: 'invalidMinMaxPassword',
      };
    }

    if (this.fnlnCheckReq && !flnFound.length) {
      this.passowrdHints.push({
        name: 'Cannot contain first name, last name, or user ID',
        formKey: 'invalidDisallowNameId',
      });
    }
  }
}
